export default function Mission() {
  return (
    <div className="mission-page">
      <div className="container">
        {/* Hero Section */}
        <section className="mission-hero">
          <h1>Our Mission: Transparency in the Kratom Industry</h1>
          <p className="hero-subtitle">
            Ending the era of overpriced, untested products sold without proper lab verification
          </p>
        </section>

        {/* Main Mission Statement */}
        <section className="mission-statement">
          <div className="statement-card">
            <h2>A New Era of Quality and Transparency</h2>
            <p>
              For too long, consumers have been taken advantage of by smoke shops and unscrupulous vendors 
              selling inferior kratom products at inflated prices. These establishments often market products 
              with flashy names and fancy packaging while providing no laboratory testing, no transparency 
              about sourcing, and no accountability for quality.
            </p>
            
            <p>
              <strong>Those days are over.</strong>
            </p>

            <p>
              At Unbiased Kratom, we believe every consumer deserves to know exactly what they're purchasing. 
              We're committed to ending the practice of selling overpriced, untested products that prey on 
              consumers' lack of knowledge about quality kratom.
            </p>

            <h3>What We Stand Against:</h3>
            <ul className="against-list">
              <li>Smoke shops charging premium prices for low-grade kratom</li>
              <li>Products sold without proper laboratory testing and certificates of analysis</li>
              <li>Misleading marketing with drug-like names and unsubstantiated claims</li>
              <li>Vendors who refuse to provide transparency about their sourcing and testing</li>
              <li>The exploitation of consumers through overpriced, inferior products</li>
            </ul>

            <h3>What We Champion:</h3>
            <ul className="champion-list">
              <li>Complete transparency in sourcing, testing, and vendor practices</li>
              <li>Honest, unbiased reviews from real customers</li>
              <li>Verified vendors who prioritize quality and customer satisfaction</li>
              <li>Education to help consumers make informed purchasing decisions</li>
              <li>Fair pricing that reflects actual product quality</li>
              <li>Laboratory-tested products with publicly available certificates of analysis</li>
            </ul>
          </div>
        </section>

        {/* Quality Standards */}
        <section className="quality-standards">
          <h2>Our Quality Standards</h2>
          <div className="standards-grid">
            <div className="standard-card">
              <div className="standard-icon">🔬</div>
              <h3>Laboratory Testing</h3>
              <p>
                Every vendor we feature must provide current laboratory testing for contaminants, 
                heavy metals, and alkaloid content. No exceptions.
              </p>
            </div>

            <div className="standard-card">
              <div className="standard-icon">📋</div>
              <h3>Certificates of Analysis</h3>
              <p>
                COAs must be readily available and current. Consumers have the right to see 
                exactly what they're purchasing before they buy.
              </p>
            </div>

            <div className="standard-card">
              <div className="standard-icon">🏪</div>
              <h3>Verified Vendors</h3>
              <p>
                Our verification process ensures vendors meet strict quality standards, 
                business practices, and customer service requirements.
              </p>
            </div>

            <div className="standard-card">
              <div className="standard-icon">💰</div>
              <h3>Fair Pricing</h3>
              <p>
                We promote vendors who offer quality products at fair prices, not those 
                who exploit consumers with inflated costs.
              </p>
            </div>

            <div className="standard-card">
              <div className="standard-icon">📞</div>
              <h3>Customer Support</h3>
              <p>
                Verified vendors must provide responsive customer service and stand 
                behind their products with clear return policies.
              </p>
            </div>

            <div className="standard-card">
              <div className="standard-icon">🌿</div>
              <h3>Product Categories</h3>
              <p>
                We provide clear categorization including traditional kratom, 7-OH products, 
                extracts, and pseudoindoxyl products for informed decision-making.
              </p>
            </div>
          </div>
        </section>

        {/* Commitment */}
        <section className="commitment">
          <div className="commitment-card">
            <h2>Our Commitment to You</h2>
            <p>
              We pledge to maintain complete independence from vendor influence. Our reviews 
              are unbiased, our standards are non-negotiable, and our mission is clear: 
              to provide you with the information you need to make informed decisions about 
              kratom products.
            </p>

            <p>
              We will never compromise our integrity for profit. We will continue to expose 
              bad actors in the industry while highlighting vendors who truly serve their 
              customers with quality, transparency, and fair pricing.
            </p>

            <div className="mission-quote">
              <blockquote>
                "Quality kratom should be accessible, affordable, and backed by science – 
                not sold as an overpriced mystery product in a smoke shop."
              </blockquote>
            </div>

            <h3>Join the Movement</h3>
            <p>
              Together, we can raise the standards of the kratom industry. By supporting 
              transparent vendors and demanding quality, we create a marketplace that 
              serves consumers rather than exploiting them.
            </p>

            <p>
              The days of paying premium prices for inferior products are over. 
              Welcome to the new era of kratom transparency.
            </p>
          </div>
        </section>

        {/* Call to Action */}
        <section className="mission-cta">
          <div className="cta-content">
            <h2>Ready to Make Informed Decisions?</h2>
            <p>
              Browse our directory of verified vendors who meet our strict standards 
              for quality, transparency, and customer service.
            </p>
            <div className="cta-buttons">
              <a href="/vendors" className="cta-button primary">
                Browse Verified Vendors
              </a>
              <a href="/reviews" className="cta-button secondary">
                Read Honest Reviews
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}